import { Shield, Wrench, CreditCard, Headphones, CheckCircle2, Star } from "lucide-react";

const features = [
    {
        icon: Shield,
        title: "Qualidade Garantida",
        description: "Segurança e conforto garantido como nenhum outro.",
    },
    {
        icon: Wrench,
        title: "Revisão Completa",
        description: "Todos os carros passam por inspeção rigorosa para garantir a qualidade.",
    },
    {
        icon: CreditCard,
        title: "Financiamento Facilitado",
        description: "Parcelas que cabem no seu bolso com as melhores taxas.",
    },
    {
        icon: Headphones,
        title: "Atendimento Personalizado",
        description: "Equipe especializada empenhada em atendê-lo.",
    },
]

const benefits = [
    "Veículos de procedência",
    "Controle de qualidade",
    "Avaliação de veículos",
    "Qualidade e durabilidade",
];

export default function FeaturesSection() {
    return (
        <section className="py-24 bg-secondary relative overflow-hidden">

            <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-primary/5 to-transparent" />
            <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-80 h-80 border border-primary/10 rounded-full" />
            <div className="absolute -left-20 top-1/2 -translate-y-1/2 w-40 h-40 border border-primary/20 rounded-full" />

            <div className="container mx-auto px-6 relative z-10">
                <div className="grid lg:grid-cols-2 gap-16 items-center">

                    <div>
                        <span className="inline-block px-4 py-2 mb-4 text-sm font-semibold tracking-widest uppercase text-primary border border-primary/30 rounded-full">
                            Por que escolher
                        </span>
                        <h2 className="text-display text-4xl md:text-5xl font-bold text-foreground mb-6">
                            Nossos <span className="text-primary">Diferenciais</span>
                        </h2>
                        <p className="text-lg text-muted-foreground mb-10">
                            Mais de 20 anos oferecendo as melhores soluções em carros para
                            transportadoras e autônomos de todo o Brasil.
                        </p>

                        <div className="grid sm:grid-cols-2 gap-6">
                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className="group p-6 bg-card rounded-lg border border-border/50 hover:border-primary/50 transition-all duration-300 hover:-translate-y-1 card-shadow"
                                >
                                    <div className="inline-flex items-center justify-center w-12 h-12 mb-4 rounded-lg accent-gradient">
                                        <feature.icon className="w-6 h-6 text-primary-foreground" />
                                    </div>
                                    <h3 className="text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                                        {feature.title}
                                    </h3>
                                    <p className="text-sm text-muted-foreground">
                                        {feature.description}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>


                    <div className="relative">
                        <div className="bg-card p-10 rounded-lg border border-border/50 card-shadow">
                            <div className="absolute -top-4 -right-4 w-24 h-24 accent-gradient rounded-lg opacity-20 blur-2xl" />

                            <h3 className="text-display text-3xl font-bold text-foreground mb-8">
                                Benefícios <span className="text-primary">Exclusivos</span>
                            </h3>

                            <div className="space-y-6">
                                {benefits.map((benefit, index) => (
                                    <div key={index} className="flex items-center gap-4">
                                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                                            <CheckCircle2 className="w-5 h-5 text-primary" />
                                        </div>
                                        <span className="text-lg font-medium text-foreground">{benefit}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-10 pt-8 border-t border-border">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <span className="text-sm text-muted-foreground">Clientes ativos</span>
                                        <p className="text-display text-3xl font-bold text-primary">2.847</p>
                                    </div>
                                    <div>
                                        <span className="text-sm text-muted-foreground">Satisfação</span>
                                        <p className="text-display text-3xl font-bold text-primary">98%</p>
                                    </div>
                                    <div >
                                        <span className="text-sm text-muted-foreground">Avaliação</span>
                                        <div className="flex items-center gap-2">
                                            <p className="text-display text-3xl font-bold text-primary">4.7</p><Star className="w-5 h-5 text-primary mr-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
